<script lang="ts">
    import Fa from 'svelte-fa'
    import { faCircleQuestion } from '@fortawesome/free-solid-svg-icons'
    import FieldHeading from './field-heading.svelte'
    import {
        ROSACEA_GRADE_LEVELS,
        ROSACEA_SUBTYPE_OPTIONS,
        createDefaultRosaceaGradeValue,
        type RosaceaGradeLevel,
        type RosaceaGradeValue,
    } from '../../types/rosacea-grade'

    export let label: string
    export let data: Record<string, any>
    export let value: RosaceaGradeValue = createDefaultRosaceaGradeValue()
    export let required = false
    export let readOnly = false

    function setGrade(key: string, grade: string) {
        value = { ...value, [key]: grade === '' ? null : (grade as RosaceaGradeLevel) }
    }

    function selectValue(e: Event): string {
        return (e.currentTarget as HTMLSelectElement).value
    }
</script>

<div class="view-field">
    <FieldHeading {label} {required} {readOnly} />
    <div class="rosacea-grade">
        {#each ROSACEA_SUBTYPE_OPTIONS as option (option.key)}
            <div class="rosacea-row" class:selected={value?.[option.key] != null && value[option.key] !== 'Ausente'}>
                <span class="rosacea-label">
                    {option.label} — {option.name}
                    <span class="rosacea-tooltip-icon" title={option.tooltip}>
                        <Fa icon={faCircleQuestion} />
                    </span>
                </span>
                <select class="rosacea-select" disabled={readOnly} value={value?.[option.key] ?? ''} on:change={(e) => setGrade(option.key, selectValue(e))}>
                    <option value="">Selecione</option>
                    {#each ROSACEA_GRADE_LEVELS as level (level)}
                        <option value={level}>{level}</option>
                    {/each}
                </select>
            </div>
        {/each}
    </div>
</div>

<style>
    .view-field {
        display: flex;
        flex-direction: column;
        width: 100%;
    }
    .rosacea-grade {
        display: flex;
        flex-direction: column;
        gap: 8px;
        width: 100%;
    }
    .rosacea-row {
        display: flex;
        align-items: center;
        justify-content: space-between;
        gap: 16px;
        width: 100%;
        padding: 10px 14px;
        border-radius: 8px;
        background: #f8f9fa;
    }
    .rosacea-row.selected {
        background: var(--cs2-accent-hover, #17be5e);
    }
    .rosacea-label {
        display: flex;
        align-items: center;
        gap: 6px;
        flex: 1;
        min-width: 0;
        font-weight: 600;
        font-size: 0.85rem;
        color: #212529;
    }
    .rosacea-row.selected .rosacea-label {
        color: #1f2937;
    }
    .rosacea-tooltip-icon {
        font-size: 0.72rem;
        color: #adb5bd;
        cursor: help;
    }
    .rosacea-row.selected .rosacea-tooltip-icon {
        color: #1f2937;
        opacity: 0.75;
    }
    .rosacea-select {
        /* Área de preenchimento é sempre clara, independente do tema do app — sem isso, o Chromium
           renderiza a lista nativa de opções (popup do <select>) escura quando o tema do app é escuro. */
        color-scheme: light;
        flex-shrink: 0;
        border: 1px solid #dee2e6;
        border-radius: 6px;
        padding: 6px 8px;
        font-size: 0.82rem;
        color: #495057;
        background: #fff;
    }
    .rosacea-select:disabled {
        cursor: not-allowed;
        opacity: 0.7;
        color: #495057 !important;
        background: #fff !important;
    }
</style>
